export const out_1_file = '/Outputs/out_1.txt';
export const out_2_file = '/Outputs/out_2.txt';
export const out_3_file = '/Outputs/out_3.txt';
export const out_4_file = '/Outputs/out_4.txt';
export const out_5_file = '/Outputs/out_5.txt';
export const out_6_file = '/Outputs/out_6.txt';
export const out_7_file = '/Outputs/out_7.txt';
export const out_8_file = '/Outputs/out_8.txt';
export const out_9_file = '/Outputs/out_9.txt';
export const sample_1_file = '/Outputs/sample_1.txt';
export const sample_2_file = '/Outputs/sample_2.txt';
export const sample_3_file = '/Outputs/sample_3.txt';
export const sample_4_file = '/Outputs/sample_4.txt';
export const sample_5_file = '/Outputs/sample_5.txt';
export const sample_6_file = '/Outputs/sample_6.txt';